import PlaceHeader from './PlaceHeader'

export default PlaceHeader
